import { useQuery } from '@tanstack/react-query';

import axios from 'src/lib/axios';
import { type QueryConfig } from 'src/lib/react-query';
import { formatResourcePath } from 'src/utils/regex';

import type { CashCollections } from 'src/features/cashCollections/types/cashCollections';
import type { ListDTO, ListResponse } from 'src/types';

const RESOURCE = '/parkings/:parkingId/cash-collections/';

type QueryFnType = typeof queryFn;

interface DTO extends ListDTO {
    parkingId: string;
    date_after?: string;
    date_before?: string;
}

type TotalAmounts = {
    total_coins_amount: number;
    total_banknotes_amount: number;
    total_amount: number;
    count: number;
};

type CollectionType = 'collect' | 'load';

interface TotalListResponse<T> extends ListResponse<T> {
    total_amounts: Record<CollectionType, TotalAmounts>;
}

const queryFn = ({ parkingId, ...params }: DTO): Promise<TotalListResponse<CashCollections>> => {
    return axios.get(formatResourcePath(RESOURCE, { parkingId }), { params });
};

interface UseQueryHookOptions extends DTO {
    config?: QueryConfig<QueryFnType>;
}
const useQueryHook = ({ config, ...payload }: UseQueryHookOptions) => {
    return useQuery({
        queryKey: [RESOURCE, payload],
        queryFn: async () => await queryFn(payload),
        ...config,
    });
};

export { useQueryHook as useListParkingCashCollections };
export type { TotalAmounts };
